import { Cell } from '@gbhem/api';

export const getDependentFields = ({ fieldId, children }: Cell): string[] =>
  [fieldId || '', ...(children || []).flatMap((c) => getDependentFields(c))].filter((c) => c);
